import React from "react";
import Button from "./Button";

const sizeClasses = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-2xl",
  xl: "max-w-4xl",
  "2xl": "max-w-5xl",
};

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  children,
  bodyClassName = "",
  panelClassName = "",
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "primary",
  showCancel = true,
  showCloseButton = true,
  footerStart = null,
  isLoading = false,
  confirmDisabled = false,
  size = "md",
  backdropClassName = "bg-black/50",
  zIndexClassName = "z-50",
  align = "top",
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={`fixed inset-0 ${zIndexClassName} overflow-y-auto px-4 py-6 ${backdropClassName}`}
      onClick={handleBackdropClick}
    >
      <div
        className={[
          "mx-auto flex min-h-full w-full justify-center",
          align === "center" ? "items-center" : "items-start",
        ].join(" ")}
      >
        <div
          className={[
            "flex w-full max-h-[calc(100vh-3rem)] flex-col overflow-hidden rounded-xl bg-white shadow-2xl dark:bg-slate-800",
            sizeClasses[size] || sizeClasses.md,
            panelClassName,
          ].join(" ")}
        >
        {/* Header */}
        {title && (
          <div className="flex items-start justify-between border-b border-slate-200 p-4 dark:border-slate-700">
            <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
              {title}
            </h3>
            {showCloseButton && (
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg p-1 text-slate-400 dark:text-slate-500 transition hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-600 dark:hover:text-slate-300"
                aria-label="Close"
              >
                <svg
                  className="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            )}
          </div>
        )}

        {/* Content */}
        <div className={["flex-1 overflow-y-auto p-4", bodyClassName].filter(Boolean).join(" ")}>
          {message && (
            <p className="text-sm text-slate-600 dark:text-slate-400">
              {message}
            </p>
          )}
          {children}
        </div>

        {/* Actions */}
        {onConfirm && (
          <div className={[
            "flex gap-3 border-t border-slate-200 p-4 dark:border-slate-700",
            footerStart ? "items-center justify-between" : "justify-end",
          ].join(" ")}>
            {footerStart ? <div>{footerStart}</div> : null}
            <div className="flex justify-end gap-3">
              {showCancel && (
                <Button
                  type="button"
                  variant="secondary"
                  size="md"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  {cancelText}
                </Button>
              )}
              <Button
                type="button"
                variant={confirmVariant}
                size="md"
                onClick={onConfirm}
                disabled={isLoading || confirmDisabled}
              >
                {isLoading ? "Processing..." : confirmText}
              </Button>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
